import { render, staticRenderFns } from "./CargaMasivaSoluciones.vue?vue&type=template&id=fb1777ec&"
import script from "./CargaMasivaSoluciones.vue?vue&type=script&lang=js&"
export * from "./CargaMasivaSoluciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports